<button>
  <svg>
    <g>
      <path
        d="M10,1c5,0,9,4,9,9s-4,9-9,9s-9-4-9-9S5,1,10,1 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0
                            L10,0z"
      />
      <polygon points="8,13.7 14,10 8,6.3" />
    </g>
  </svg>
</button>
